import { StationDispatchContext } from '../types/station-journey';
import HttpHelpers from './helpers';

const StationsApiEndpoints = {
  getDispatchContext: (stationCode: string): Promise<StationDispatchContext> => (
    HttpHelpers.unAuthenticatedAxios
      .get<StationDispatchContext>(`/api/v1/stations/${encodeURIComponent(stationCode)}/dispatch_context`)
      .then((response) => response.data)
  ),
};

export default StationsApiEndpoints;
